export const DEFAULT_OVERLAY_WIDTH = 640;
